const RESOURCE_NAME = '/geopoints';
import restApi from "@/api/rest-api-object";

export default axios => (restApi(axios, RESOURCE_NAME));